import { QueryClient } from '@tanstack/react-query';

/**
 * App-wide react-query client.
 *
 * PoC scope: this backs the Files module's attachment reads/writes only
 * (see `modules/files/useFiles.ts`). As more *server* state migrates off
 * hand-rolled `useState`/`useEffect` (and eventually off the Redux thunks in
 * `projectSlice`), it reuses this same client — one cache, one place to tune
 * staleness/retries.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Attachments rarely change out from under the user mid-session; a short
      // stale window collapses the repeated "fetch on every mount" the old
      // code did manually into deduped cache hits.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
